import React from 'react';

const WhatWeDo = () => {
  const services = [
    {
      icon: "fas fa-shield-alt",
      title: "Safety System Design",
      description: "Comprehensive design of safety instrumented systems tailored to your facility"
    },
    {
      icon: "fas fa-chart-line",
      title: "Risk and SIL Assessment",
      description: "Thorough evaluation of risks and determination of required Safety Integrity Levels"
    },
    {
      icon: "fas fa-clipboard-check",
      title: "Compliance and Standards Support",
      description: "Ensuring adherence to IEC 61508, IEC 61511, and industry standards"
    },
    {
      icon: "fas fa-sync-alt",
      title: "Lifecycle Management",
      description: "End-to-end management of safety systems throughout their operational life"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">What We Do</h2>
          <p className="text-xl text-gray-600">Comprehensive functional safety solutions for hazardous industries</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <i className={`${service.icon} text-3xl text-blue-600`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 relative">
          <img
            src="/assets/asset-13.jpg"
            alt="Process control panel"
            className="w-full rounded-lg shadow-xl opacity-80"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
